import { HexPattern } from '../brand/Hexagon';
import { Button } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
import { finalCta } from '../../content/site';

export function FinalCta() {
  return (
    <section
      id="cta"
      className="relative overflow-hidden bg-brand section-y"
      aria-labelledby="cta-titulo"
    >
      <div className="pointer-events-none absolute inset-0 text-white" aria-hidden="true">
        <HexPattern className="h-full w-full" opacity={0.08} />
      </div>

      <div className="shell relative">
        <Reveal className="mx-auto max-w-[900px] text-center">
          <h2
            id="cta-titulo"
            className="text-[clamp(2rem,4.4vw,3.4rem)] leading-[1.1] text-white"
          >
            {finalCta.title}
          </h2>

          <p className="mx-auto mt-6 max-w-[640px] text-[16.5px] leading-[1.75] text-white/85">
            {finalCta.paragraph}
          </p>

          <div className="mt-10 flex flex-wrap justify-center gap-3.5">
            <Button href={finalCta.primary.href} variant="inverse">
              {finalCta.primary.label}
            </Button>
            <Button href={finalCta.secondary.href} variant="ghost">
              {finalCta.secondary.label}
            </Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
